module.exports = __webpack_public_path__ + "static/img/compass_ani.8a3552f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/compass_ani.png
// module id = EDdR
// module chunks = 5